import React, { memo } from 'react'

import { bool, string } from 'prop-types'

import GenerateButton from './Components/GenerateButton/GenerateButton'
import PrivateModeSelector from './Components/PrivateModeSelector/PrivateModeSelector'

function GenerateArea({
  withPrivateModeSelector = false,
  generateLabel,
  generatedLabel,
  generatingLabel,
  isEnhancementMode = false,
  isGenerateDisabled = false,
  tooltipMessage = undefined,
  withIcon = true,
}) {
  return (
    <div className="generate-area">
      {withPrivateModeSelector && <PrivateModeSelector />}
      <GenerateButton
        generateLabel={generateLabel}
        generatedLabel={generatedLabel}
        generatingLabel={generatingLabel}
        isEnhancementMode={isEnhancementMode}
        isDisabled={isGenerateDisabled}
        tooltipMessage={tooltipMessage}
        withIcon={withIcon}
      />
    </div>
  )
}

GenerateArea.propTypes = {
  withPrivateModeSelector: bool,
  generateLabel: string.isRequired,
  generatedLabel: string.isRequired,
  generatingLabel: string.isRequired,
  isEnhancementMode: bool,
  isGenerateDisabled: bool,
  tooltipMessage: string,
  withIcon: bool,
}

export default memo(GenerateArea)
